export enum SettlementFundOptionsEnum {
  VG_FEDERAL_MONEY_MARKET_FUND = 'VG_FEDERAL_MONEY_MARKET_FUND',
  VG_CASH_DEPOSIT = 'VG_CASH_DEPOSIT',
}
export enum SettlementFundAoAEnum {
  FED = 'FED',
  VCD = 'VCD',
}

export enum SettlementFundFullNameEnum {
  FED = 'Vanguard Federal Money Market Fund',
  VCD = 'Vanguard Cash Deposit',
}

export const SettlementFundMap: { [key in SettlementFundAoAEnum]: string } = {
  [SettlementFundAoAEnum.FED]: SettlementFundFullNameEnum.FED,
  [SettlementFundAoAEnum.VCD]: SettlementFundFullNameEnum.VCD,
};
